import React, { useEffect, useState } from "react";
import styles from "./styles";
import { Grid } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import CanvasJSReact from '../../../canvasjs.react';
import { isMobile } from "react-device-detect";
import "animate.css/animate.css";

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

// import NewGraph  from "../NewGraph";

const Graph1 = (props) => {
  const {
    classes,
    submitted,
    setAnsweredCorrectly,
    questionAnswer,
    setAnsweredPartialy,
    setAnswers,
    answers,
    step,
    setSubmit,
    selected,
    setSelected,
    resetStatesFun,
    questionNumber
  } = props;

  const [onSelect, setOnSelect] = useState(-1);
  const [correctAnswer, setCorrectAnswer] = useState(questionAnswer.answer);
  const [chartData, setChartData] =useState([])
  let data = [
    {
      type: "line",
      color: '#003e4c',
      lineThickness: isMobile ? 3 : 6,
      dataPoints: [{x: 8, y: 16}, {x: 0, y: 0}]
    },
    {
      type: "line",
      color: '#02b1d9',
      lineThickness: isMobile ? 3 : 6,
      dataPoints: [{y: 15, x: 0}, {x: 18, y: 6}]
    },
    {
      type: "line",
      color: '#003e4c',
      lineDashType: "shortDash",
      lineThickness: isMobile ? 3 : 6,
      dataPoints: [{x: 0, y: 12}, {x: 6, y: 12}]
    },
    {
      type: "line",
      color: '#003e4c',
      lineDashType: "shortDash",
      lineThickness: isMobile ? 3 : 6,
      dataPoints: [{x: 6, y: 0}, {x: 6, y: 12}]
    },
    {
      type: "bubble",
      indexLabel: "S",
      indexLabelFontFamily: 'Rubik',
      indexLabelFontSize: isMobile ? 18 : 26,
      indexLabelFontColor: '#003e4c',
      indexLabelFontWeight: "bold",
      dataPoints: [{x: 8, y: 14, markerType: 'none'}]
    },
    {
      type: "bubble",
      indexLabel: "D",
      indexLabelFontFamily: 'Rubik',
      indexLabelFontSize: isMobile ? 18 : 26,
      indexLabelFontColor: '#02b1d9',
      indexLabelFontWeight: "bold",
      dataPoints: [{x: 14, y: 7, markerType: 'none'}]
    }
    // {
    //   type: "line",
    //   color: '#003e4c',
    //   lineDashType: "shortDash",
    //   lineThickness: isMobile ? 3 : 6,
    //   dataPoints: [{x: 10, y: 0}, {x: 10, y: 10}]
    // },
  ]

  const options = {
    colorSet: "colorSet2",
    cursor: "pointer",
    title: {
      text: isMobile ? "" : "",
      fontColor: "#transparent",
      fontFamily: "Rubik",
      fontWeight: "bold",
      fontSize: 24,
      // padding: {
      //   top: 10,
      //   bottom: 0,
      // },
    },
     axisX:{
      lineColor: "#003e4c",
      lineThickness: 3,
      gridThickness: 1,
      gridColor: "#cecece",
      labelFontColor: "#003e4c",
      labelFontSize: isMobile ? 12 : 16,
      // labelFontWeight: "bold",
      labelFontFamily: "Rubik",
      interval: 1,
      minimum: 0,
      maximum: questionNumber === 1 ? 20 : 15,
      labelFormatter: function(e) {
        return e.value % 5 === 0 ? e.value : "";
      }
    },
    axisY:{
      lineColor: "#003e4c",
      lineThickness: 3,
      labelFontSize: isMobile ? 12 : 16,
      // labelFontWeight: "bold",
      labelFontFamily: "Rubik",
      gridThickness: 1,
      labelFontColor: "#003e4c",
      gridColor: "#cecece",
      interval:  1,
      minimum: 0,
      maximum: questionNumber === 0 ? 20 : 15,
      margin: 10,
      labelFormatter: function(e) {
        return e.value % 5 === 0 ? e.value : "";
      }
      // title: " asdas",
    },
    toolTip: {
      enabled: false,
    },
    data: chartData,
    height: isMobile ? 230 : 400,
    width: isMobile ? 300 : 490,
  }

  useEffect(() => {
    setChartData(data)
  }, [])


  const changeBackground = (e) => {
    if (!submitted) {
      e.target.style.background = "#a3cfd9";
    }
  };

  const resetBackground = (e) => {
    if (!submitted) {
      e.target.style.background = "";
    }
  };

  const resetStates = () => {
    setSubmit(false)
    setSelected([])
    data[2].color = "#003e4c"
    data[3].color = "#003e4c"
    // data[3].color = "#003e4c"
    setChartData(data)
  }

  resetStatesFun(resetStates)

  useEffect(() => {
    setTimeout(() => {
      setCorrectAnswer(questionAnswer.answer)
      resetStates()
    }, 2)
  }, [questionAnswer.answer, step])


  const markSelected = (triangle) => {
    if (!submitted) {
      setOnSelect(1);
      let temp = selected;
      if (selected.includes(triangle)) {
        const index = temp.indexOf(triangle);
        // if (index > -1) {
        temp.splice(index, 1);
        // }
        // temp.pop(triangle);
        setSelected(temp);
      } else {
        temp.push(triangle);
        setSelected(temp);
      }

      if (
        selected.includes(2) && selected.includes(5)) {
          data[2].color = "#00b1d9"
      }
      if (
        selected.includes(3) && selected.includes(4)) {
          data[3].color = "#00b1d9"
      }
    }
    setChartData(data)
    console.log("selected", selected)
  };

  useEffect(() => {
    setOnSelect(2);
  }, [onSelect]);

  const notQuiteFun = () => {
    let is_partial = "F";
    selected.map((ans) => {
      if (is_partial || is_partial === "F") {
        is_partial = true;
      }
      if (!questionAnswer.answer.includes(ans)) {
        is_partial = false;
      }
    });
    return is_partial === true ? true : false;
  };

  useEffect(() => {
    let is_true = true;
    questionAnswer.answer.map((ans) => {
      if (!selected.includes(ans)) {
        is_true = false;
      }
    });
    const answer = is_true && selected.length === questionAnswer.answer.length;
    if (submitted && step === 1) {
      let tempAnswer = answers;
      if (answer) {
        tempAnswer.push(true);
        setAnswers(tempAnswer);
        if (
          questionAnswer.answer.includes(2) ||
          questionAnswer.answer.includes(5)
        ) {
           data[2].color = "green"
        }
        if (
          questionAnswer.answer.includes(3) ||
          questionAnswer.answer.includes(4)
        ) {
           data[3].color = "green"
        }
        setAnsweredCorrectly(true);
      } else {
        tempAnswer?.push(false);
        setAnswers(tempAnswer);
        let is_partial = false;
        if (selected.length < questionAnswer.answer.length) {
          is_partial = notQuiteFun();
        }
        if (is_partial) {
          setAnsweredPartialy(true);
        } else {
          setAnsweredPartialy(false);
          setAnsweredCorrectly(false);
        }
        if (
          questionAnswer.answer.includes(2) ||
          questionAnswer.answer.includes(5)
        ) {
           data[2].color = "green"
        }
        if (
          questionAnswer.answer.includes(3) ||
          questionAnswer.answer.includes(4)
        ) {
           data[3].color = "green"
        }

        if ((selected.includes(2) && !questionAnswer.answer.includes(2)) || (selected.includes(5) && !questionAnswer.answer.includes(5))) {
          data[2].color = "red"
        }
        if ((selected.includes(3) && !questionAnswer.answer.includes(3)) || (selected.includes(4) && !questionAnswer.answer.includes(4))) {
          data[3].color = "red"
      }
      }
    }
    setChartData(data)
  }, [submitted]);

  const checkSelection = (triangle) => selected.includes(triangle);

  const demandCurveResponsive = () => {
    return (
      <div className={classes.internationalContainerMajor}>
        <div className={classes.internationalContainerChild} >
        {(step > 0 || (step === 0 && submitted)) && <h4 className={classes.pLabels}>P</h4> }
        {step > 0 &&
        <>
          <div style={{ display: "flex", flexDirection: "column", position: "absolute", height: "100%", left: isMobile? -30 : -40, top: isMobile ? 18 : 40 }}>
            <h4  className={classes.yLabels} dangerouslySetInnerHTML={{__html: "P<sub>e</sub>" }}/>
          </div>
          <div style={{ display: "flex", position: "absolute", bottom: isMobile ? -7 : -60, marginLeft: isMobile ? "41%" : "52%", width: "100%" }}>
            {step === 3 &&
              <h4  className={"centerDot"} style={{ left: 90, bottom: -27, position: "absolute", width: 40, height: 40, border: "5px solid #00b1d9", borderRadius: "50%" }}/>
            }
            <h4 className={classes.yLabels}  dangerouslySetInnerHTML={{__html: "Q<sub>e</sub>" }}/>
          </div>
          </>
          }
          {(step > 0 || (step === 0 && submitted)) && <h4 className={classes.qLabels}>Q</h4> }
          <CanvasJSChart options={options} />
          {step > 0 &&
          <>
          <div className={classes.shape2Major}>
            <div
              className={classes.shape2Child}
              style={{
                float: "left",
                clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
                shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
                backgroundColor: submitted
                  ? correctAnswer.includes(2)
                    ? "green"
                    : selected.includes(2)
                    ? "red"
                    : "transparent"
                  : selected.includes(2)
                  ? "#00b1d9"
                  : "transparent",
              }}
              onMouseOut={
                selected.includes(2)
                  ? console.log("hhhh")
                  : !checkSelection(2) && resetBackground
              }
              onMouseOver={
                selected.includes(2)
                  ? console.log("2")
                  : !checkSelection(2) && changeBackground
              }
              onClick={() => markSelected(2)}
            >
              {/* { selected.includes(2) && <img src={selected.includes(2) ? TAHov : ""} alt=""  width={"100%"} height={"100%"}/> } */}
              {/* <img src={selected.includes(2) ? TAHov : section1} alt=""  width={"100%"} height={"100%"}/> */}
            </div>
          </div>

          <div className={classes.shape5Major}>
            <div
              className={classes.shape5Child}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(5)
                    ? "green"
                    : selected.includes(5)
                    ? "red"
                    : ""
                  : selected.includes(5)
                  ? "#00b1d9"
                  : "transparent",
              }}
              onMouseOut={
                selected.includes(5)
                  ? console.log("hhhh")
                  : !checkSelection(5) && resetBackground
              }
              onMouseOver={
                selected.includes(5)
                  ? console.log("5")
                  : !checkSelection(5) && changeBackground
              }
              onClick={() => markSelected(5)}
            />
          </div>

          <div className={classes.shape3Major}>
            <div
              className={classes.shape3Child}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(3)
                    ? "green"
                    : selected.includes(3)
                    ? "red"
                    : ""
                  : selected.includes(3)
                  ? "#00b1d9"
                  : "transparent",
              }}
              onMouseOut={
                selected.includes(3)
                  ? console.log("hhhh")
                  : !checkSelection(3) && resetBackground
              }
              onMouseOver={
                selected.includes(3)
                  ? console.log("3")
                  : !checkSelection(3) && changeBackground
              }
              onClick={() => markSelected(3)}
            />
          </div>
{/* 
          <div className={classes.shape4Major}>
            <div
              className={classes.shape4Child}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(4)
                    ? "green"
                    : selected.includes(4)
                    ? "red"
                    : ""
                  : selected.includes(4)
                  ? "#00b1d9"
                  : "transparent",
              }}
              onMouseOut={
                selected.includes(4)
                  ? console.log("hhhh")
                  : !checkSelection(4) && resetBackground
              }
              onMouseOver={
                selected.includes(4)
                  ? console.log("4")
                  : !checkSelection(4) && changeBackground
              }
              onClick={() => markSelected(4)}
            />
          </div> */}

          </>}
        </div>
      </div>
    );
  };

  return <Grid className={classes.graphContainer}>
    {demandCurveResponsive()}
    </Grid>;
};

export default withStyles(styles)(Graph1);
